import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
//import { PurchaseEvents } from './PurchaseEvents';
import { DomSanitizer } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import { BsModalRef } from "ngx-bootstrap/modal";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";

@Component({
  selector: "modal-content",
  templateUrl: "./print.html",
})
export class PrintData {
  @Output() partyUpdateEvent = new EventEmitter();
  row: any;
  data: any = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  designList = [];
  typeList = ["Fresh", "Damage"];
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  userTypeList = [{ type: "ADMIN" }, { type: "USER" }];
  statusList = [{ name: "ACTIVE" }, { name: "INACTIVE" }];
  printdata;
  printInv: boolean = false;
  @Input() set printcontent(val: any) {
    this.printdata = this.sanitizer.bypassSecurityTrustHtml(val);
    this.printInv = true;
  }

  @Input() set printdet(val: any) {
    this.printdata = this.sanitizer.bypassSecurityTrustHtml(val);
  }

  @Input() set printreturn(val: any) {
    this.printdata = val;
    //this.printdata = this.sanitizer.bypassSecurityTrustHtml(val);
  }
  @Input() set printreturndet(val: any) {
    this.printdata = this.sanitizer.bypassSecurityTrustHtml(val);
  }
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("statusAuto") statusAuto;
  @ViewChild("shiftauto") shiftauto;
  shiftCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    public toasterService: ToasterService
  ) {
    // this.mode = this.stockdata.mode;
  }
  ngOnInit() {}
  ngAfterViewInit() {
    setTimeout(() => {
      $("#design_num").focus();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (
      nextEl == "f36" ||
      "f38" ||
      "f40" ||
      "f42" ||
      "f44" ||
      "h36" ||
      "h38" ||
      "h40" ||
      "h42" ||
      "h44"
    ) {
      $("#" + nextEl).select();
    } else {
      $("#" + nextEl).focus();
    }
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;
    var mywindow = window.open("", "Print", "height=950,width=800");

    mywindow.document.write(content);

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/print/print.ts